import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useCheckin from "hooks/useCheckin";
import { QRScanner } from "organisms/qr-scanner/QRScanner";

const ScanCheckInPage = () => {
  const [scannedQRCode, setScannedQRCode] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong - please contact support if this issue persists"
  );
  const navigate = useNavigate();

  const { checkinUser, isLoading, isError, isSuccess } = useCheckin({
    onSuccess: () => {
      setScannedQRCode("");
    },
    onError: (err) => {
      if (err.response.status == 400) {
        setErrorMessage("Unrecognized QR code - please try again");
      }
    },
  });

  const handleShowErrorMessage = useCallback(() => {
    if (isError) {
      setShowErrorMessage(true);
      return setTimeout(() => {
        setShowErrorMessage(false);
        setScannedQRCode("");
      }, 2000);
    }
  }, [isError]);

  useEffect(() => {
    const timeoutId = handleShowErrorMessage();
    return () => clearTimeout(timeoutId);
  }, [handleShowErrorMessage]);

  const handleScanResult = useCallback(() => {
    if (scannedQRCode && !showErrorMessage && !isLoading && !isSuccess) {
      checkinUser(scannedQRCode);
    }
  }, [scannedQRCode, showErrorMessage, isLoading, isSuccess, checkinUser]);

  useEffect(() => {
    handleScanResult();
  }, [handleScanResult]);

  return (
    <QRScanner
      errorMessage={showErrorMessage ? errorMessage : undefined}
      onClose={() => navigate(-1)}
      onResult={setScannedQRCode}
    />
  );
};

export default ScanCheckInPage;
